import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { VendorTaxCertificationsPage } from './VendorTaxCertificationsPage';
import { getTaxCertificationsAsyncAction } from 'store/vendorStore/vendorTaxCertifications/slices';
import { eTaxCertificationRequestStatus } from 'types/order/title/eTaxCertificationRequestStatus';
import { ISearchOrderTaxCertReqSettingsData } from 'types/vendorDashboard/ISearchOrderTaxCertReqSettingsData';
import { VendorWrapper } from '../../components/vendorDashboard/VendorWrapper';
import { VendorSelectors } from '../../selectors/vendorPortal/VendorSelectors';
import { useAppDispatch } from '../../store/store';

export const VendorTaxCertificationsContainer: React.FC = () => {
  const dispatch = useAppDispatch();
  const [updateInformation, setUpdateInformation] = useState(false);
  const {
    data: taxCerts,
    query: searchSettings,
    fetchError: taxCertsError,
    fetchStatus: taxCertsFetchStatus,
  } = useSelector(VendorSelectors.selectTaxCertifications);

  useEffect(() => {
    if (!updateInformation) {
      // update info if user return from another page
      setUpdateInformation(true);
      dispatch(getTaxCertificationsAsyncAction(searchSettings));
    }
  }, [dispatch, taxCerts, updateInformation, searchSettings]);

  const onFilterOrder = async (status: eTaxCertificationRequestStatus[]) => {
    dispatch(
      getTaxCertificationsAsyncAction({
        statuses: status,
        pageNumber: searchSettings.pageNumber,
        fileNumber: searchSettings.fileNumber,
        pageSize: searchSettings.pageSize,
      } as ISearchOrderTaxCertReqSettingsData)
    );
  };

  const onPageSizeUpdate = (pageSize: number) => {
    dispatch(
      getTaxCertificationsAsyncAction({
        statuses: searchSettings.statuses,
        pageNumber: searchSettings.pageNumber,
        fileNumber: searchSettings.fileNumber,
        pageSize: pageSize,
      } as ISearchOrderTaxCertReqSettingsData)
    );
  };

  const onPageUpdate = (page: number) => {
    dispatch(
      getTaxCertificationsAsyncAction({
        statuses: searchSettings.statuses,
        pageNumber: page,
        fileNumber: searchSettings.fileNumber,
        pageSize: searchSettings.pageSize,
      } as ISearchOrderTaxCertReqSettingsData)
    );
  };

  const onSearchTaxCertifications = (value: any) => {
    dispatch(
      getTaxCertificationsAsyncAction({
        statuses: searchSettings.statuses,
        pageNumber: searchSettings.pageNumber,
        pageSize: searchSettings.pageSize,
        fileNumber: value.fileNumber,
      } as ISearchOrderTaxCertReqSettingsData)
    );
  };

  return (
    <VendorWrapper isLoading={taxCertsFetchStatus.fetching}>
      <VendorTaxCertificationsPage
        pageError={taxCertsError}
        taxCerts={taxCerts.taxCerts}
        searchSettings={taxCerts.setting}
        loadingTaxCerts={taxCertsFetchStatus.fetching}
        onFilterPayoff={onFilterOrder}
        onPageSizeUpdate={onPageSizeUpdate}
        onPageUpdate={onPageUpdate}
        onSearchTaxCerts={onSearchTaxCertifications}
      />
    </VendorWrapper>
  );
};
